import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ProductList from "../Product/ProductList";

const mapStateToProps = state => {
    return {
        searchValue: state.search.searchValue
    }
}

class SearchResults extends React.Component {
    constructor() {
        super();
        this.resultsFallback = this.resultsFallback.bind(this);
        this.state = {
            numResults: null,
            showProductList: true
        }
    }

    resultsFallback(numResults) {
        this.setState({ numResults });
    }

    componentDidUpdate(prevProps) {
        document.title = 'Search results for "' + this.props.searchValue + '" | Veronica Virta';
        
        if (prevProps.searchValue !== this.props.searchValue) {
            this.setState({
                showProductList: true,
                numResults: null
            });
        } else if (this.state.numResults === 0 && this.state.showProductList === true) {
            this.setState({
                showProductList: false
            })
        }
    }

    render() {
        var queryVars = new URLSearchParams(this.props.location.search);
        var search = queryVars.get("q");

        var resultsNum = "";
        if (this.state.numResults > 0) {
            resultsNum = "(" + this.state.numResults + ")";
        }

        return <div className="search-page">
            <div className="page-title">
                <b>Results:</b> {search} {resultsNum}
            </div>

            { this.state.showProductList && <ProductList queryVars={{ search }} resultsFallback={this.resultsFallback} /> }

            <div className="no-results-wrap" hidden={this.state.showProductList}>
                <span className="text">No search results found. Try something else.</span>
            </div>
        </div>;
    }
}

export default withRouter(connect(mapStateToProps)(SearchResults));